module.exports = __webpack_public_path__ + "img/i-analys.dda3be04.png";